import PropTypes from 'prop-types';
import React from 'react';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import firebaseui from 'firebaseui';

import {firebase, db, Timestamp} from './firebase';
import {CurrentUserContext} from './Router';

// Configure FirebaseUI.
const get_firebase_ui_config = (loginUser, history) => {
  return {
    signInFlow: 'redirect',
    credentialHelper: firebaseui.auth.CredentialHelper.NONE,
    signInOptions: [
      firebase.auth.EmailAuthProvider.PROVIDER_ID,
    ],
    tosUrl: 'https://skipscooters.com/terms/',
    callbacks: {
      // TODO: update to signInSuccessWithAuthResult
      signInSuccess: async (currentUser) => {
        const {uid: userId} = currentUser;

        const userDoc = await db.collection('/users').doc(userId).get();
        loginUser(currentUser, userDoc);

        history.push('/');

        await db.collection('/users').doc(userId).set({
          lastSeenAt: Timestamp.now(),
        }, {merge: true});

        return false;
      }
    }
  }
}

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  render() {
    const {history} = this.props;

    return (
      <div>
        <img src={`${process.env.PUBLIC_URL}/skip-logo.png`} height="60" width="142" className="my-3 mx-auto d-block" alt="" />
        <CurrentUserContext.Consumer>
          {({loginUser}) => (
            <StyledFirebaseAuth
              uiConfig={get_firebase_ui_config(loginUser, history)}
              firebaseAuth={firebase.auth()}
            />
          )}
        </CurrentUserContext.Consumer>
      </div>
    )
  }
}

LoginPage.propTypes = {
  history: PropTypes.object.isRequired,
};

export {LoginPage};



// WEBPACK FOOTER //
// ./src/LoginPage.js